import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from '@/store';
import type { FileCloneStatus } from '@/types/poc/helia';

const selectHeliaFiles = (state: RootState) => state.helia.files;
const selectCloneQueue = (state: RootState) => state.cloneQueue.queue;
const selectCurrentlyCloning = (state: RootState) => state.cloneQueue.currentlyCloning;
const selectFailedFiles = (state: RootState) => state.cloneQueue.failedFiles;

export const selectFileCloneStatusMap = createSelector(
  [selectHeliaFiles, selectCloneQueue, selectCurrentlyCloning, selectFailedFiles],
  (heliaFiles, queue, currentlyCloning, failedFiles): Record<string, FileCloneStatus> => {
    const statusMap: Record<string, FileCloneStatus> = {};

    for (const cid of Object.keys(heliaFiles)) {
      statusMap[cid] = 'cloned';
    }

    if (currentlyCloning !== null) {
      statusMap[currentlyCloning.cid] = 'cloning';
    }

    for (const queuedFile of queue) {
      statusMap[queuedFile.cid] ??= 'pending';
    }

    for (const cid of Object.keys(failedFiles)) {
      statusMap[cid] ??= 'failed';
    }

    return statusMap;
  },
);

export const selectFileCloneErrorMap = createSelector(
  [selectFailedFiles],
  (failedFiles): Record<string, string> => failedFiles,
);
